import EmberRoute from '@ember/routing/route';

import { service } from '@ember/service';

/**
 * Ember Route extensions.
 * Remember to call super on any overridden hooks.
 */
export default class Route extends EmberRoute {
  @service ssr;

  afterModel(model) {
    this.setHeadTags?.(model);
  }
}
